// Copyright (c) 2017 Deere & Company

import * as helpers from './helpers';
import React, {
    PropTypes,
    PureComponent
} from 'react';
import DealerHierarchyAccount from './dealer-hierarchy-account';

class DealerHierarchyAccounts extends PureComponent {

    handleAccountChange = account => () => {

        const selectedAccount = account.dealer.account;
        const selectedAccounts = helpers.updateSelectionMap(this.props.selectedAccounts, selectedAccount);
        const accountsToCheck = helpers.getHashesToCheck(this.props.accounts, 'dealer.account');

        this.props.onAccountChange({
            account,
            accountsToCheck,
            selectedAccount,
            selectedAccounts
        });

    };

    render() {

        return (
            <ul className='accounts'>
                {this.props.accounts.map((account, accountIndex) =>
                    <DealerHierarchyAccount
                        account={account.dealer}
                        id={`${account.id}-${accountIndex}`}
                        key={accountIndex}
                        onAccountChange={this.handleAccountChange(account)}
                        selectedAccounts={this.props.selectedAccounts}
                    />
                )}
            </ul>
        );

    }

}

DealerHierarchyAccounts.displayName = 'DealerHierarchyAccounts';
DealerHierarchyAccounts.propTypes = {
    accounts: PropTypes.array.isRequired,
    onAccountChange: PropTypes.func.isRequired,
    selectedAccounts: PropTypes.object.isRequired
};

export default DealerHierarchyAccounts;



// WEBPACK FOOTER //
// ./src/shared/components/facets/dealer-hierarchy/dealer-hierarchy-accounts.js